/**
 * Boot error (SHELL-005).
 *
 * Rendered by the boundary in main.tsx when a JavaScript error occurs before
 * the shell has painted anything. Unlike every other screen, it does not use
 * `Screen` or assume `<Router>`, the live regions, or even `#main` as rendered
 * by `App.tsx` exist -- nothing downstream of the crash is known to be intact,
 * which is the difference between this and SHELL-006's `RouteError`. A reload
 * is the only control offered for the same reason.
 */
export function BootError() {
  return (
    <main id="main" class="shell" tabIndex={-1}>
      <h1>Puzzle Gate can&rsquo;t start</h1>
      <p>Something went wrong before the app could load. Reloading usually fixes this.</p>
      <button
        type="button"
        onClick={() => {
          window.location.reload();
        }}
      >
        Reload
      </button>
    </main>
  );
}
